const CN_DOWN_LINK =
  'https://cdn-cloudprint.cainiao.com/waybill-print/cainiao-x-print/prod/win/cainiao-x-print-win-86.exe?spm=a219a.7386653.0.0.214c669aAlb85m&file=cainiao-x-print-win-86.exe'

export { CN_DOWN_LINK }
